/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralCitytaxRepository = (options: GeneralRestApiOptions): Types.GeneralCitytaxRepository => ({
    async getbycode(params, requestOptions) {
        return options.request('/citytax/getbycode', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
